import React from 'react';

import { Sublink, DropdownContainer } from '../DesktopNavbar.styles';

interface Props {
  displayDropdown: boolean;
  links: any[];
}

export function Dropdown({ displayDropdown, links }: Props) {
  return displayDropdown ? (
    <DropdownContainer dropdownSize={links.length} data-testid="nav-dropdown">
      {(links || []).map(({ fields: { title, url, openInNewTab } }: any) => (
        <Sublink
          data-testid="nav-dropdown-sublink"
          key={title}
          href={url}
          target={openInNewTab ? '_blank' : '_self'}
        >
          {title}
        </Sublink>
      ))}
    </DropdownContainer>
  ) : null;
}
